import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-md";

const RMDButton = ({children, ...otherProps}) => (
  <Button 
    className={"RMDButton-Root"}
    raised
    {...otherProps}
  >
    {children}
  </Button>
);

RMDButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
};

export default RMDButton;